var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { class: _vm.tableClass },
    [
      _vm._l(_vm.rows, function (row, index) {
        return [
          row.display
            ? _c(
                "div",
                { key: index, staticClass: "row row-border no-side-padding" },
                [
                  _c("div", { class: _vm.buildCellClass("label", row.label) }, [
                    _vm._v(_vm._s(row.label)),
                  ]),
                  _vm._v(" "),
                  _c("div", { class: _vm.buildCellClass("value", row.value) }, [
                    _vm._v(_vm._s(row.value)),
                  ]),
                ]
              )
            : _vm._e(),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }